import { render } from "./MyBind.vue?vue&type=template&id=d07c669e&scoped=true"
import script from "./MyBind.vue?vue&type=script&lang=js"
export * from "./MyBind.vue?vue&type=script&lang=js"

import "./MyBind.vue?vue&type=style&index=0&id=d07c669e&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\website-shuziyun\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d07c669e"]])

export default __exports__